import { render } from "./RoleSelectModal.vue?vue&type=template&id=ee3515ba&scoped=true"
import script from "./RoleSelectModal.vue?vue&type=script&lang=js"
export * from "./RoleSelectModal.vue?vue&type=script&lang=js"

import "./RoleSelectModal.vue?vue&type=style&index=0&id=ee3515ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3515ba"]])

export default __exports__